module.exports = __webpack_public_path__ + "img/smell-2.7e3f9341.svg";